<template>
    <div class="fabric-select-btn-box">
        <div v-bind:class="[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]"
             v-on:touchstart="touchstartup"v-on:mouseenter="scrollup" v-on:mouseleave="mouseleave" v-on:touchend="touchend">
            <div class="top-arrow-text"
                 v-bind:style="[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                {{ translations['Scroll up for further fabrics'] }}
            </div>
        </div>
        <div id="{{ box.component }}" class="fabric-select-btns" @scroll="itemsScroll">
            <div v-for="button in fabrics | filterBy filtercolor in 'color' | filterBy filterpattern in 'pattern' | filterBy filterweave in 'weave'| filterBy filtermaterial in 'material' | filterBy filteroccasion in 'occasion' | filterBy priceBetween | filterBy newFilter | filterBy topseller | filterBy filtername in 'name'"
                 class="fabric-select-btn">
                <div class="fabric-select-img">
                    <span v-bind:class="[ 'mask', (isactive === button.ref_number || button.ref_number === this.personal[box.component] || (button.ref_number === 'none' && this.personal[box.component] === 'neutral')) ? 'active' : '' ]"
                          v-bind:id="button.ref_number" @click="updatePersonal" v-bind:data-component="box.component"
                          v-bind:data-fabric_quality="button.quality" v-bind:data-price="button.price"></span>
                    <img v-bind:src="this.baseurl + 'media/'+ button.thumb+''" alt=""
                         v-bind:title="button.name" v-bind:class="active"/>
                </div>
                <div class="name" v-bind:id="button.ref_number" @click="updatePersonal"
                     v-bind:data-component="box.component"
                     v-bind:data-fabric_quality="button.quality" v-bind:data-price="button.price">{{ button.name }}
                </div>
                <button v-if="button.ref_number !== 'none'"
                        v-bind:class="[ 'zoom-btn', 'btn-standalone', (isactive === button.ref_number || button.ref_number === this.personal[box.component]) ? 'active' : '' ]"
                        type="button" @click="zoomFabric" v-bind:data-refnr="button.ref_number"
                        v-bind:data-title="button.name" v-bind:data-infotext='button.infotext'
                        v-bind:data-price='button.price' v-bind:data-weave="button.weave" v-bind:data-yarn="button.yarn"
                        v-bind:data-weight="button.weight" v-bind:data-composition="button.composition" v-bind:data-zoom="button.zoom"
                        title="{{ translations['Further informations'] }}">Details
                </button>
            </div>
        </div>
    </div>
    <div v-bind:class="[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]"
         v-on:touchstart="touchstartdown" v-on:mouseenter="scrolldown" v-on:mouseleave="mouseleave" v-on:touchend="touchend">
        <div class="bottom-arrow-text"
             v-bind:style="[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
            {{ translations['Scroll down for further fabrics'] }}
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals" :muster1="muster1" :muster2="muster2"
          :muster3="muster3" :muster4="muster4"></zoom>
</template>

<script>
import Zoom from './Zoom.vue'

export default {
  name: 'Fabrics',
  components: {
    Zoom
  },
  props: [ 'baseurl', 'box', 'fabrics', 'filtercolor', 'showcolor', 'filterpattern', 'showpattern', 'filterweave', 'showweave', 'filtermaterial', 'showmaterial', 'filteroccasion', 'showoccasion', 'filtername', 'showname', 'range1', 'range2', 'showprice', 'boolfilter', 'fields', 'personal', 'muster1', 'muster2', 'muster3', 'muster4', 'zoom' ],
  data: function () {
    return {
      isactive: '',
      show: {
        type: Boolean,
        required: true,
        twoWay: true
      },
      globals: window.shirtdesigner,
      scrolling: false,
      touchstart: false,
      translations: window.shirtdesigner.translations,
      selectedScrollHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0),
      selectedClientHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0),
      scrollPosition: 0
    }
  },
  methods: {
    updatePersonal: function (event) {
      this.$dispatch('updatePersonal', event)
      this.isactive = event.currentTarget.id
    },
    priceBetween: function (a) {
      if (a.price >= this.range1.value && a.price <= this.range2.value) {
        return a
      }
    },
    topseller: function (a) {
      if (this.boolfilter['topseller'] === '1') {
        if (a.topseller === '1') return a
      } else {
        return a
      }
    },
    newFilter: function (a) {
      if (this.boolfilter['new'] === '1') {
        if (a.new === '1') return a
      } else {
        return a
      }
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    },
    addSample: function (event) {
      /*global localStorage: false */
      var exists = false
      var message = ''
      var free = ''
      var keys = ['muster1', 'muster2', 'muster3', 'muster4']
      var i = 0
      var key
      while (keys[i]) {
        key = keys[i]
        if (localStorage.getItem(key)) {
          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
            exists = key
            break
          }
        } else {
          if (!free) free = key
        }
        i++
      }
      if (!exists && free) {
        localStorage.setItem(free, JSON.stringify(event.currentTarget.dataset.refnr))
        this.$dispatch('setSwatch', {key: free, value: event.currentTarget.dataset.refnr})
        this.$dispatch('setMsg', {success: this.translations['Added to swatch box.']})
      } else {
        if (exists) {
          localStorage.removeItem(key)
          this.$dispatch('setSwatch', {key: key, value: ''})
          message = this.translations['Removed from swatch box.']
          this.$dispatch('setMsg', {success: message})
        } else {
          message = this.translations['You have already four fabrics in swatch box.']
          this.$dispatch('setMsg', {error: message})
        }
      }
    },
    scrolldown: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop + scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    scrollup: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop - scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    mouseleave: function () {
      if (this.scrolling) {
        window.clearInterval(this.scrolling)
        this.scrolling = false
      }
    },
    touchstartup: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop - scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchstartdown: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop + scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchend: function () {
      this.mouseleave()
    },
    checkMeasures: function () {
      this.selectedScrollHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0)
      this.selectedClientHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0)
    },
    itemsScroll: function () {
      var ele = document.getElementById(this.box.component)
      this.scrollPosition = ele.scrollTop
      this.checkMeasures()
    }
  },
  watch: {
    fabrics: function () {
      this.checkMeasures()
    },
    filtercolor: function () {
      this.checkMeasures()
    },
    showcolor: function () {
      this.checkMeasures()
    },
    filterpattern: function () {
      this.checkMeasures()
    },
    showpattern: function () {
      this.checkMeasures()
    },
    filterweave: function () {
      this.checkMeasures()
    },
    showweave: function () {
      this.checkMeasures()
    },
    filtermaterial: function () {
      this.checkMeasures()
    },
    showmaterial: function () {
      this.checkMeasures()
    },
    filteroccasion: function () {
      this.checkMeasures()
    },
    showoccasion: function () {
      this.checkMeasures()
    },
    filtername: function () {
      this.checkMeasures()
    },
    showname: function () {
      this.checkMeasures()
    },
    range1: function () {
      this.checkMeasures()
    },
    range2: function () {
      this.checkMeasures()
    },
    showprice: function () {
      this.checkMeasures()
    },
    boolfilter: function () {
      this.checkMeasures()
    }
  },
  ready: function () {
    this.checkMeasures()
  }
}

</script>


// WEBPACK FOOTER //
// Fabrics.vue?8fa71102